import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import Button from '../components/button/Button'
import { toast } from 'react-toastify';
import { ParseErrors } from '../utils/parse-errors';
import axiosInstance from '../utils/axios-instance';

interface ICreateNewAgency {
    toggleUserModel: () => void;
}

const CreateNewAgency = ({ toggleUserModel }: ICreateNewAgency) => {
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState<Record<string, any>>({})

    const onCreateUser = async () => {
        setLoading(true)
        try {
            await axiosInstance.post('/auth/register', { ...values, internal: true })
            toggleUserModel()
            setLoading(false)
        } catch (error) {
            toast.error(ParseErrors(error))
            toggleUserModel()
            console.log(error)
            setLoading(false)
        }
    }

    const HandleOnChange = (e) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const inputClass = "mt-1 w-full h-12 border border-gray-200 rounded-xl px-4 text-[14.5px] outline-none placeholder-gray-400";
    const labelClass = "block text-[13px] font-medium text-lightBlack";

    return (
        <div className='w-full h-full fixed top-0 bg-black/50 backdrop-blur-sm left-0 z-50 flex items-center justify-center px-4'>
            <div className='p-7 rounded-2xl bg-white shadow-pop w-full max-w-[480px] fade-up'>
                <div className="flex items-center justify-between">
                    <h2 className='font-display text-lg font-semibold tracking-tight text-lightBlack'>Create Agency</h2>
                    <button onClick={toggleUserModel} className="h-9 w-9 rounded-lg bg-gray-50 hover:bg-gray-100 flex items-center justify-center transition" aria-label="Close">
                        <FontAwesomeIcon icon={faXmark} className="text-lightBlack text-base" />
                    </button>
                </div>

                <div className='w-full mt-6 space-y-4'>
                    <div>
                        <label className={labelClass}>Name</label>
                        <input name="name" placeholder="Agency name" onChange={HandleOnChange} className={inputClass} />
                    </div>
                    <div>
                        <label className={labelClass}>Email</label>
                        <input name="email" placeholder="agency@example.com" onChange={HandleOnChange} className={inputClass} />
                    </div>
                    <div>
                        <label className={labelClass}>Password</label>
                        <input name="password" type="password" placeholder="Set a password" onChange={HandleOnChange} className={inputClass} />
                    </div>
                    <div className="pt-3">
                        <Button isLoading={loading} disabled={loading} onClick={onCreateUser}>Create Agency</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateNewAgency
